var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmark = function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "m17.33 7.94-3.11 7.04h-2.34v3.27l-2.98-1.9-2.98 1.9v-3.27H4.77c-1.58 0-2.37-1.02-2.37-3.07 0-.76.1-1.36.29-1.82A37.52 37.52 0 0 1 5.78 4c.28-.42.54-.74.78-.98s.54-.42.89-.56c.35-.14.76-.21 1.24-.21h8.52l-3.85 7.86H4.77l-.27.01a.75.75 0 0 0-.26.1.7.7 0 0 0-.26.28c-.05.1-.1.29-.16.53a4.7 4.7 0 0 0 .16 2.23c.06.1.14.2.25.26.11.05.2.09.26.1h1.43v-1.89h1.36v4.05l1.62-1.03 1.63 1.03v-4.05h1.35v1.9h1.45l2.52-5.7h1.48ZM6.9 4.74c-.65.98-1.37 2.32-2.16 4.01h7.78l2.52-5.15H8.69c-.44 0-.77.08-1 .22-.2.15-.47.45-.79.92Z"
  })));
};
export default SvgBookmark;